import { useEffect, useState } from "react";

import { useTrendingImagesQuery } from "queries";
import { IGif } from "services/types";
import { TileItem } from "components/feed/TileItem";
import { SeeMoreBlock } from "components/blocks";
import { routes } from "routes";
import { ViewRegion } from "utils/metrics";
import { GifBlockPlaceholder } from "components/UI/Skeleton";

const MAX_TILES = 6;

export const TrendingImages = (): JSX.Element => {
  const [gifs, setGifs] = useState<IGif[]>([]);

  const query = useTrendingImagesQuery();

  useEffect(() => {
    if (query.isSuccess && query.data) {
      setGifs(query.data.gifs.slice(0, MAX_TILES));
    }
  }, [query.isSuccess, query.data]);

  const renderGifs = () => {
    if (!gifs.length) {
      return new Array(MAX_TILES).fill("").map((___, index) => <GifBlockPlaceholder key={index} />);
    }

    return gifs.map((gif: IGif, key: number) => (
      <TileItem
        key={key}
        thumbnail={gif.urls.poster}
        video={gif.type === 1 ? gif.urls.sd : undefined}
        published={gif.published}
        verified={gif.verified}
        link={routes.watch(gif.id)}
        views={gif.views}
        duration={gif.duration}
        gallery={!!gif.gallery}
        manage={false}
        source={ViewRegion.Main}
        index={key}
      />
    ));
  };

  return (
    <SeeMoreBlock
      header="🔥️ Trending Images"
      more={routes.exploreImages()}
      className="trendingImages"
    >
      {renderGifs()}
    </SeeMoreBlock>
  );
};
